module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Thin.7a1459b.otf";